// import { Row, Col, Button, Modal, Form, div } from "react-bootstrap";
import DataTable from "react-data-table-component";
import React, { Fragment, useLayoutEffect, useRef } from "react";
import * as Icon from "react-bootstrap-icons";
import { useLocation, useNavigate } from "react-router";
import "../crmComponents/Contacts.css";
import { useState, useEffect, useCallback } from "react";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
//Redux-imports
import { useDispatch, useSelector } from "react-redux";
import {
  deleteLead,
  exportLeadDetails,
  fetchLeadsList,
} from "../../redux/actions/crmActions";
import Loading from "../assetLibComponents/Loading";
import { DebounceInput } from "react-debounce-input";
import { ArrowLeft } from "react-bootstrap-icons/dist";
import { Dialog, Transition } from "@headlessui/react";
import TabManagement from "../TabManagement";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import moment from "moment";
import { DateRange, DateRangePicker } from "react-date-range";


const LeadView = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const leadsList = useSelector((state) => state.crmLeads?.leadsList?.response);
  const leadsListTotal = useSelector((state) => state.crmLeads?.leadsList?.lead_count);
  const isLoading = useSelector((state) => state.crmLeads.loading);
  const [show, setShow] = useState(false);
  const [tabName, setTabName] = useState("Lead View");
  const [searchValue, setSearchValue] = useState("");

  // Tailwind

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const tabs = [
    { name: "Lead View", href: "/Lead-Management", current: true },
    { name: "Account View", href: "/Account", current: false },
  ];
  
  const checkbox = useRef();
  const [checked, setChecked] = useState(false);
  const [page, setPage] = useState(1);
  const currentDate = moment();
  const location = useLocation();
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false)
  const [sortVal, setSortVal] = useState("")
  const [deleteModal, setDeleteModal] = useState(false);
  const [rangeString, setRangeString] = useState(location.state?.startDate ? location.state?.rangeString:"all");
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = React.useState(location.state?.startDate ? {
    startDate: location.state?.startDate,
    endDate: location.state?.endDate,
  } :{
    startDate: null,
    endDate: null,
  });
  const [selectedDates, setSelectedDates] = React.useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const handleCalendar = (ranges) => {
    setShowCalendar(false);
    const { startDate, endDate } = selectedDates[0];
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

    const formattedRange = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    setDateRange(formattedRange);
  };

  const handleCheckboxChange = (obj) => {
    if (selectedPeople.includes(obj)) {
        setSelectedPeople(selectedPeople.filter(item => item !== obj));
      } else {
        setSelectedPeople([...selectedPeople, obj]);
      }
  };

  const handleSelectAll = (e) => {
    setSelectedAll(true);
    setSelectedPeople(leadsList);
  };
  
  const getChars = (str) => {
    if (str === "") {
      return;
    }
    const firstLetters = str
      .split(" ")
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return firstLetters;
  };

  const deleteHandleClose = () => {
    setDeleteModal(false);
    setSelectedPeople([]);
  };
  
  const nextPage = (e) => {
    setPage(e);
    dispatch(fetchLeadsList(props.authToken,"",sortVal,e,dateRange?.startDate,
    dateRange?.endDate));
  }

  // Tailwind
  useEffect(() => {
    dispatch(fetchLeadsList(props.authToken));
  }, []);

  const handleRemoveSearch = (e) => {
    setSearchValue("");
    // dispatch(searchInput(""));
    dispatch(fetchLeadsList(props.authToken, ""));
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    dispatch(fetchLeadsList(props.authToken, e.target.value));
  };

  const handleTagClick = (buttonType) => {
    setShowCalendar(false);
    const currentDate = moment();
    setRangeString(buttonType);
    setSelectedDates([
      {
        startDate: new Date(),
        endDate: null,
        key: "selection",
      },
    ]);

    switch (buttonType) {
      case "all":
        setDateRange({
          startDate: "",
          endDate: "",
        });
        break;
      case "today":
        setDateRange({
          startDate: currentDate.format("YYYY-MM-DD"),
          endDate: currentDate.format("YYYY-MM-DD"),
        });
        break;
      case "yesterday":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
          endDate: currentDate.clone().subtract(1, "day").format("YYYY-MM-DD"),
        });
        break;
      case "lastWeek":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "week")
            .startOf("week")
            .format("YYYY-MM-DD"),
          endDate: currentDate
            .clone()
            .subtract(1, "week")
            .endOf("week")
            .format("YYYY-MM-DD"),
        });
        break;
      case "lastMonth":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: currentDate
            .clone()
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
        });
        break;
      default:
        // Default case
        break;
    }
  };

  useEffect(() => {
    dispatch(
      fetchLeadsList(
        props.authToken,"",sortVal,page,
        dateRange?.startDate,
        dateRange?.endDate
      )
    );
  }, [dateRange]);

  useEffect(() => {
    setPage(1)
    dispatch(fetchLeadsList(props.authToken,"",sortVal,0,dateRange?.startDate,
    dateRange?.endDate));

  }, [sortVal]);


  return (
    <>
      {isLoading && <Loading />}
      {leadsList && (
        <div className="pt-[2rem] bg-gray-100 h-[91.5vh]">
        {/*New Heading And Bar */}
          <div className="mx-12 max-sm:mx-4 flex max-sm:block justify-between border-b border-gray-200 mb-3 mt-1 my-auto">
            <TabManagement tabs={tabs} setTabName={setTabName} tabName={tabName} />
            <div className="top flex max-lg:justify-start justify-center pb-4 pt-1 ">
          <div className="flex max-sm:block my-auto items-center relative">
            {/* <div className="text-lg leading-7 font-[500] mr-2 max-sm:my-4">
            Conversation History
          </div> */}
            <div className="tagsContainer flex max-sm:mb-2">
              <div
              className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                rangeString === "all"
                  ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                  : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
              }`}
              onClick={() => {
                handleTagClick("all");
              }}
            >
              All
            </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "today"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("today");
                }}
              >
                Today
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "yesterday"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("yesterday");
                }}
              >
                Yesterday
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "lastWeek"
                    ? " border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("lastWeek");
                }}
              >
                Last Week
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] border cursor-pointer mr-1  ${
                  rangeString === "lastMonth"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("lastMonth");
                }}
              >
                Last Month
              </div>
            </div>
            <div className="flex flex-wrap">
              {dateRange.endDate !== null && rangeString === "calendar" && (
                <div
                  className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer me-1 ${
                    rangeString === "calendar"
                      ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                      : ""
                  }`}
                  onClick={() => {
                    setShowCalendar(!showCalendar);
                    setRangeString("calendar");
                  }}
                >
                  {dateRange?.startDate}/{dateRange?.endDate}
                </div>
              )}
              {(selectedDates[0].endDate == null ||
                dateRange.endDate == null) && (
                <div
                  className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] flex mr-1 my-auto cursor-pointer ${
                    rangeString === "calendar"
                      ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                      : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                  }`}
                  onClick={() => {
                    setShowCalendar(!showCalendar);
                    setRangeString("calendar");
                    setDateRange({
                      startDate: null,
                      endDate: null,
                    });
                  }}
                >
                  Choose Time Duration{" "}
                  <Icon.CalendarDate className="ml-1 my-auto" />
                </div>
              )}
            </div>
              {showCalendar && (
                <div className="font-[Inter] z-[20] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] bg-[white] left-3/4 top-[119%] z-10 border border-gray-400 max-sm:left-0 max-sm:top-full text-xs mr-1 my-auto absolute">
                  <DateRange
                    editableDateInputs={true}
                    onChange={(ranges) => {
                      setSelectedDates([ranges.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={selectedDates}
                    showMonthAndYearPickers={true}
                    showDateDisplay={false}
                    // initialFocusedRange={[17-18]}
                  />
                  <div className="flex w-full">
                    <div className="ms-auto flex">
                      <div
                        className="py-[8px] px-[16px] bg-[#4D9AFF] rounded-[20px] text-center text-white outline-none border-none cursor-pointer mr-2"
                        onClick={() => setShowCalendar(false)}
                      >
                        Cancel
                      </div>
                      <div
                        className="py-[8px] px-[16px] bg-[#4D9AFF] rounded-[20px] text-center text-white outline-none border-none cursor-pointer"
                        onClick={() => {
                          handleCalendar();
                        }}
                      >
                        OK
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
            <div className="max-sm:w-full max-sm:pb-2">
              <button
                onClick={() => {
                  if (props.subPageName === "leadView") {
                    navigate(`/Lead-Management/addLeads`);
                  } else if (props.subPageName === "accounts") {
                    navigate(`/Lead-Management/addAccounts`);
                  }
                }}
                type="button"
                className="my-auto max-sm:w-[30%] max-sm:justify-center mr-3 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
              >
                + New <p className="max-sm:hidden">Contact</p>
              </button>
              <button
                onClick={() => navigate(`/Lead-Management/leadImport`)}
                type="button"
                className="mr-3 my-auto max-sm:w-[30%] max-sm:justify-center inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
              >
                Import
              </button>
              <button
                onClick={() => dispatch(exportLeadDetails(props.authToken))}
                type="button"
                className="my-auto inline-flex max-sm:w-[30%] max-sm:justify-center items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
              >
                Export
              </button>
            </div>
          </div>
          
          <div className="w-full flex justify-between pb-2 px-12 max-sm:px-4">
            <div className="relative rounded-md shadow-sm my-auto w-[30%] max-sm:w-[50%]">
              <DebounceInput
                value={searchValue}
                className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-300 sm:text-sm sm:leading-6"
                placeholder="Search Leads..."
                minLength={3}
                debounceTimeout={500}
                onChange={handleSearch}
              />
              <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
                {searchValue && searchValue !== "" ? (
                  <Icon.X
                    className="h-4 w-4 text-gray-400 pointer"
                    onClick={handleRemoveSearch}
                  />
                ) : (
                  <Icon.Search
                    className="h-4 w-4 text-gray-400 cursor-pointer"
                    onClick={handleSearch}
                  />
                )}
              </div>
            </div>
            <div className="flex rightTop">
              <div className="filterContainer flex items-center">
                <div className="filterSelect h-full max-sm:flex max-sm:justify-end">
                  <select
                    aria-label="select-sortby"
                    className="h-[90%] block w-full max-sm:w-[100%] rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-[0.7rem]"
                    onChange={(e) => {
                        // setFilterByOption(e.target.value);
                        let fiValue;
                        if (e.target.value === "null") {
                          fiValue = "";
                        } else {
                          setSortVal(e.target.value)
                          fiValue = e.target.value;
                          // setPage(1);
                          // setSelectedRow(null)
                          // setSideChat(false);
                        }
                      }}
                    // value={filterByOption}
                  >
                    <option value="" className="hidden">Sort</option>
                    <option value="ASC">Activity (Asc)</option>
                    <option value="DESC">Activity (Dsc)</option>
                    {/* <option value="t-asc">Title (A to Z)</option>
                    <option value="t-desc">Title (Z to A)</option> */}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {selectedPeople.length > 0 && <div className="flex max-sm:flex-col text-xs shadow-[0px_5px_10px_0px_#E5E7EB] pt-4 pb-1 mt-2 sm:pt-2 lg:pt-2 mx-4 sm:mx-6 lg:mx-12 bg-white rounded-lg items-center justify-between px-4 sm:px-6 py-5 max-sm:py-2 sm:p-1.5 border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)]">
            <p className="max-sm:mb-2 max-sm:font-bold">{selectedPeople?.length}{" Selected"}</p>
            <div className="flex ml-auto mr-0 items-center">
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-3" onClick={() => setDeleteModal(true)}>
                    <Icon.Trash3/> <span>Delete</span>
              </div>
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-3" onClick={() => { setSelectedPeople([]) }}>
                    <Icon.Subtract/> <span>Unselect All</span>
              </div>
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-3" onClick={handleSelectAll}>
                  <Icon.UiChecks/> <span>Select All</span>
              </div>
            </div>
          </div>}
          
          <div className="shadow-[0px_5px_10px_0px_#E5E7EB] pb-1 mt-2 mx-4 sm:mx-6 lg:mx-12 bg-white rounded-lg">
            <div className="flow-root">
              <div className={"overflow-x-auto listing "+(selectedPeople.length > 0 ? "xl:h-[50vh] max-sm:h-[55vh] md:h-[42vh] h-[42vh]" : "xl:h-[58vh] md:h-[50vh] max-sm:h-[60vh] h-[50vh]")}>
                <div className="inline-block min-w-full py-0 align-middle sm:px-6 lg:px-0">
                  <div className="relative">
                    <table className="min-w-full divide-y divide-gray-300 ">
                      <thead className="bg-gray-50 sticky top-0 z-10">
                        <tr className="border-gray-200 border-b">
                          <th
                            scope="col"
                            className="relative px-7 sm:w-12 sm:px-6"
                          >
                          </th>
                            <th
                              scope="col"
                              className="py-3.5 w-3/12 pr-3 text-left text-sm font-semibold text-gray-900"
                            >
                              Name
                            </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Phone Number
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Company
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Source
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Last Activity
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                          </th>
                        </tr>
                      </thead>
                      
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {leadsList.length > 0 && leadsList?.map((item) => (
                          <tr
                            key={item?.id}
                            className={
                              selectedPeople?.includes(item)
                                ? "bg-cyan-50 border-b border-solid"
                                : undefined
                            }
                          >
                            <td className="relative px-7 sm:w-12 sm:px-6">
                              <input
                                type="checkbox"
                                className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-white"
                                checked={selectedPeople?.includes(item)}
                                onChange={() => {
                                  handleCheckboxChange(item);
                                }}
                              />
                            </td>
                            <td
                              onClick={() => {
                                navigate(
                                  `/Lead-Management/leadDetail/${item.id}`
                                );
                              }}
                              className={classNames(
                                "whitespace-nowrap flex items-center py-4 pr-3 text-sm font-medium cursor-pointer",
                                selectedPeople?.includes(item)
                                  ? "text-gray-900"
                                  : "text-gray-900"
                              )}
                            >
                              <div className="bg-amber-100 rounded-[50%] flex w-8 h-8 flex-col justify-center items-center gap-[17.5px] shrink-0 p-[12.25px] mr-4">
                                <span className="capitalize text-amber-500 text-center text-base not-italic font-semibold leading-6">{getChars(item?.name || "Unknown")}</span>
                              </div>
                              <div className={(item?.email === "" ? "flex items-center": "")}>
                                <span title={item?.name} className="text-sm capitalize not-italic font-semibold leading-5">
                                {item?.name?.length > 20
                                  ? `${item?.name.slice(0, 20)}...`
                                  : item?.name}
                                </span>
                                <p title={item?.email} className="text-xs not-italic font-normal leading-4">
                                {item?.email?.length > 25
                                  ? `${item?.email.slice(0, 25)}...`
                                  : item?.email}
                                </p>
                              </div>
                              
                            </td>
                            <td
                              title={item?.phone}
                              className="whitespace-nowrap px-3 py-4 text-gray-500 cursor-default text-sm not-italic font-normal leading-5"
                            >
                              {item?.phone?.length > 15
                                ? `${item?.phone.slice(0, 15)}...`
                                : item?.phone}
                            </td>
                            <td
                              title={item?.company}
                              className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 cursor-default"
                            >
                                <div className={(item?.company_website === "" ? "flex items-center": "")}>
                                <span title={item?.company} className="text-sm capitalize not-italic font-semibold leading-5">
                                {item?.company?.length > 20
                                  ? `${item?.company.slice(0, 20)}...`
                                  : item?.company}
                                </span>
                                <p title={item?.company_website} className="text-xs not-italic font-normal leading-4">
                                {item?.company_website?.length > 25
                                  ? `${item?.company_website.slice(0, 25)}...`
                                  : item?.company_website}
                                </p>
                              </div>
                            </td>
                            <td
                              title={item?.source}
                              className="whitespace-nowrap capitalize px-3 py-4 text-sm text-gray-500 cursor-default"
                            >
                              {item?.source?.length > 20
                                ? `${item?.source.slice(0, 20)}...`
                                : item?.source}
                            </td>
                            <td
                              title={item?.created_date}
                              className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 cursor-default"
                            >
                              {item?.created_date?.slice(0, 10)}
                            </td>
                            <td className="flex justify-end px-3 py-4 text-right text-sm text-gray-500 cursor-default" >
                              <span onClick={() => handleCheckboxChange(item)}>
                                <Icon.ThreeDotsVertical title="select" className={(selectedPeople.includes(item) ? 'cursor-pointer text-[20px] text-[var(--brand-primary)]':"cursor-pointer text-[20px] text-[#A8A8A8] hover:text-[var(--brand-primary)]")}/>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    
                    {(leadsList?.length === 0) && (
                      <div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[5%] h-full font-[bolder] font-add text-center">
                        <span className="flex justify-center text-[40px]">
                          <Icon.Inbox />
                        </span>
                        No Data
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {leadsListTotal > 10 && <div className="flex mx-4 sm:mx-6 lg:mx-12 my-4">
            <div className="me-auto">
              <ResponsivePagination
                current={page}
                total={Math.ceil(leadsListTotal/10)}
                onPageChange={nextPage}
              />
            </div>
          </div>}
          <Transition.Root show={deleteModal} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              onClose={deleteHandleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                      <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start">
                          <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                            <ExclamationTriangleIcon
                              className="h-6 w-6 text-red-600"
                              aria-hidden="true"
                            />
                          </div>
                          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                            <Dialog.Title
                              as="h3"
                              className="text-base font-semibold leading-6 text-gray-900"
                            >
                              Delete Lead(s)?
                            </Dialog.Title>
                            <div className="mt-2">
                              <p className="text-sm text-gray-500">
                                Are you sure you want to delete ?
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                        <button
                          type="button"
                          className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                          onClick={() => {
                            dispatch(
                              deleteLead(props.authToken, selectedPeople)
                            );
                            setSelectedAll(false);
                            setSelectedPeople([]);
                            deleteHandleClose(false);
                          }}
                        >
                          Yes
                        </button>
                        <button
                          type="button"
                          className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                          onClick={() => deleteHandleClose(false)}
                        >
                          No
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </div>
      )}
    </>
  );
};

export default LeadView;
